import React from 'react';
import cx from 'classnames';

import { sizeDown } from 'utils/components';

import Avatar, { AvatarLoading } from 'components/Avatar';
import { ServiceTypes } from 'constants/constants';
import { TwitchLogo, YouTubeLogo } from 'components/Svg';

export const ChannelCardLoading = ({channel, className, size = 'm', layout = 'row', ...props}) => (
  <div className={cx("g-channel-card", "loading", className, size, layout)} {...props}>
    <AvatarLoading size={sizeDown(size)} />
    <div className="name loading-text" />
  </div>
);


export const ChannelCard = ({channel, className, size = 'm', layout = 'row', showLogo = null, showName = true, children, ...props}) => (
  <div className={cx("g-channel-card", className, size, layout, { 'no-name': !showName })} {...props}>
    <Avatar src={channel?.avatarUrl} size={sizeDown(size)} badge={ 
      showLogo === 'badge' 
        ? <>
            { channel?.service === ServiceTypes.TWITCH
              ? <TwitchLogo size={'m'} />
              : null}
            { channel?.service === ServiceTypes.YOUTUBE
              ? <YouTubeLogo size={'m'} />
              : null}
          </>
        : null }>
    </Avatar>
    <div>
      { showName && 
      <div className="name">
        <span>{channel?.displayName ?? channel?.serviceName}</span>
        { showLogo === 'name' && 
          <div className='badge'>
            { channel?.service === ServiceTypes.TWITCH
              ? <TwitchLogo size={'m'} />
              : null}
            { channel?.service === ServiceTypes.YOUTUBE
              ? <YouTubeLogo size={'m'} />
              : null}
          </div>}
      </div>}
      { children && <div className="extra">{ children }</div>}
    </div>
  </div>
);
export default ChannelCard;